import PixelObject from './PixelObject'

export default class Frame extends PixelObject {
    constructor(options) {
        super(options);

        const defaults = {
            type: 'FRAME',
            name: 'Frame',
            width: 50,
            height: 50,
            clip: true
        }

        let opts = { ...defaults, ...options }

        this.type = opts.type
        this.name = opts.name
        this.width = opts.width
        this.height = opts.height
        this.clip = opts.clip

        this.createBuffer(this.width, this.height)
    }

    set(key, newValue) {
        let config = {
            url: () => { }
        }

        if (config[key]) {
            const oldValue = this[key]
            let parsedValue = config[key]({ newValue, oldValue })
            console.log(key, newValue, oldValue, parsedValue)
            if (oldValue != parsedValue) {
                this[key] = parsedValue
                this.dispatch('objectStateChanged', this.propertyChangedMessage(key))
            }
        } else {
            PixelObject.prototype.set.call(this, key, newValue)
        }
    }

    copy(args) {
        return new Frame({ ...this, ...args, skipParentGeneration: true })
    }

    renderBuffer() {
        console.log("Frame regenerating")

        const self = this

        this.buffer.clear()

        // console.time("iterationTime")
      
        this.buffer.clear()
        this.buffer.resizeCanvas(this.getRenderPropertyValue('width'), this.getRenderPropertyValue('height'))
 
        this.children.slice().reverse().forEach(e => {
            const element = e.getCachedCopy({ forcedUpdate: true })
            element.ctx = this.buffer
            element.setRenderScaleProperties(this.renderScaleOptions)
            if (this.renderScaleOptions) {
                element.setRenderPositionBasedOnScaleProperties(this.renderScaleOptions)
            }
            element.draw()
        })
        
        // console.timeEnd("iterationTime");

        this.stop = false
    }

    draw() {
        if (this.visible == '0' || this.deleted) return

        this.ctx.push()

        const width = this.getRenderPropertyValue('width')
        const height = this.getRenderPropertyValue('height')

        if (!this.stop) {
            this.stop = true
            this.image = this.buffer.get()
        }

        if (this.image) {
            this.position()
            
            if (this.opacity !== 100) {
                
                this.ctx.tint(255,  this.opacity)
            }
            this.ctx.image(this.image, -width / 2, -height / 2, width, height);
        }

        this.ctx.pop()
    }
}